import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { Button } from "../../../ui/button/button";
import { Modal } from '../../../../core/services/modal';

@Component({
  selector: 'app-statement-modal',
  imports: [Button, TranslatePipe],
  templateUrl: './statement-modal.html',
  styleUrl: './statement-modal.css'
})
export class StatementModal {
  @Input() options?: any;

  constructor(private modalService: Modal) { }

  close(): void {
    this.modalService.close();
  }

  onDownload(): void {
    // If parent provided a custom callback, call it
    if (this.options?.onConfirm && typeof this.options.onConfirm === 'function') {
      this.options.onConfirm();
    } else {
      // Otherwise, emit event to parent or close by default
      this.close();
    }
    this.close();
  }

  cancel(): void {
    this.close();
  }
}
